import api from "@apiSvc/apiSvc";
import conversion from "@conversionSvc/conversionSvc";
import projectListing from "@projectListingSvc/projectListingSvc";
import validation from "@validationSvc/validationSvc";

const services = {
  api,
  conversion,
  projectListing,
  validation,
};

export default services;
